import { useTranslation } from "react-i18next"
import { ErrorPage } from "../ErrorPage"
import { SubmissionSuccessPage } from "../SubmissionSuccessPage"

interface Props {
  isSubmitting?: boolean
  isSuccess?: boolean
  isError?: boolean
  onRetry?: () => void
  error?: string | null
}

export function SubmissionSplashPage({
  isSubmitting,
  isSuccess,
  isError,
  onRetry,
  error,
}: Props) {
  const { t } = useTranslation()

  return isSubmitting ? (
    <div className="flex justify-center mt-20">
      <div className="flex justify-center bg-[#E9E9E9] w-full mx-20 p-24">
        <div className="[font-size:var(--core-font-size-lg)] [font-family:var(--core-font-family-sans)]">
          {t("client.submission.loading")}
        </div>
      </div>
    </div>
  ) : isSuccess ? (
    <SubmissionSuccessPage />
  ) : isError ? (
    <div className="flex flex-col h-[100vh] mt-20 items-center">
      <ErrorPage
        title={t("client.submission.error.title")}
        errorMessage={t("client.submission.error.message")}
        retryText={t("client.submission.error.button")}
        onRetry={() => onRetry?.()}
        error={error}
      />
    </div>
  ) : null
}
